/** Bullets, dashes, numbers or bare lines, whichever the model reached for. */
const parseLines = raw => raw.split('\n').map(line => line.replace(/^\s*(?:[-*•]|\d+[.)])\s*/, '').replace(/^["']|["']$/g, '')).filter(line => line.trim().length > 0);

/**
 * A block that opens with `[` or `{` is claiming to be JSON. If it then fails to parse,
 * line-splitting it would render `["One?",` or `{oops` as a chip, so broken JSON yields nothing and
 * the block stays visible in the prose instead.
 */
const parseBlock = raw => {
  if (!/^[[{]/.test(raw)) return parseLines(raw);
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter(s => typeof s === 'string') : [];
  } catch (_unused) {
    return [];
  }
};

/**
 * The model closes each reply with a fenced `suggestions` block of follow-up questions. Split it
 * out so the chips render as chips and the fence never leaks into the prose.
 *
 * Both shapes are accepted. The prompt asks for a bullet list and the model reliably produces one,
 * but an earlier version of this parser took JSON only: a bullet list parsed as zero suggestions
 * and the block was stripped anyway, so the chips silently disappeared from every reply.
 */
export function splitSuggestions(content) {
  const match = content.match(/```suggestions\s*([\s\S]*?)```/);
  if (!match) return {
    body: content,
    suggestions: []
  };
  const suggestions = parseBlock(match[1].trim()).map(s => s.trim()).filter(Boolean).slice(0, 4);

  // The block is always removed, parsed or not. It holds follow-up prompts and nothing else, so
  // dropping a malformed one loses no part of the answer, and leaving it would show the reader a
  // raw fence.
  return {
    body: content.replace(match[0], '').replace(/\n{3,}/g, '\n\n').trim(),
    suggestions
  };
}